import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {
    TRIGGER_CREATE_REQUEST,
    TRIGGER_CREATE_SUCCESS,
    TRIGGER_CREATE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const CreateTriggerAction = (data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_PLATFORMJK}/api/triggers`,
        method: 'POST',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            TRIGGER_CREATE_REQUEST,
            {
                type: TRIGGER_CREATE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": TRIGGER_CREATE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: TRIGGER_CREATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": TRIGGER_CREATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {CreateTriggerAction}